//VERIGO OPERATOR

import en_US from '../../en_US';

const extend = {
  tv: 'TV'
};

const en_VERIGO = {...en_US, ...extend};

export default en_VERIGO;



// WEBPACK FOOTER //
// ./src/locales/dics/ext/povtv/en_POVTV.js